import { useEffect, useState } from "react";
import InputBar from "../shared/InputBar";
import Loader from "../shared/Loader";
import useChatPageData from "../../utils/hooks/useChatPageData";

const CurrentChat = ({ onBack, chat, onSelectChat }) => {
  const { activeChatsList = [] } = useChatPageData();

  const [localChat, setLocalChat] = useState(chat);

  useEffect(() => {
    setLocalChat(chat);
  }, [chat]);

  if (!localChat) {
    return (
      <div className="w-full h-[calc(100vh-100px)] flex items-center justify-center">
        <Loader size={40} color="black" />
      </div>
    );
  }

  const { customer, sessionStarted, messages = [] } = localChat;

  return (
    <div className="flex flex-col flex-1 w-full h-full pr-2 gap-y-2">
      {/* Top Avatars for All Chats */}
      {/* <div className="flex flex-row items-center pr-2 justify-between border-2 w-full border-white shadow-[4px_4px_47.1px_0px_#00000040] rounded-lg"> */}

      {/* Main Chat Header */}
      <div className="flex flex-row justify-between items-center w-full pr-2 py-2 border-white shadow-[4px_4px_47.1px_0px_#00000040] rounded-lg">
        <div className="flex flex-row gap-2 overflow-x-auto px-2">
          {activeChatsList.map((item) => (
            <div key={item.id} className="relative">
              <img
                src={item.customer.avatar}
                alt={item.name}
                onClick={() => onSelectChat(item.id)}
                className={`w-[30px] h-[30px] rounded-full cursor-pointer object-cover border ${
                  item.id === localChat.id
                    ? "border-black"
                    : "border-transparent"
                }`}
              />
              <div className="w-[10px] h-[10px] border-2 border-white rounded-full absolute bottom-0 right-0 bg-[#4DFF00]" />
            </div>
          ))}
        </div>

        <img
          src="/icons/down-arrow2.png"
          alt="down-arrow"
          className="w-[12px] h-[12px] rounded-full object-cover cursor-pointer"
          onClick={onBack}
        />
      </div>

      {/* Chat Messages */}
      <div className="w-full h-full flex flex-col shadow-[4px_4px_47.1px_0px_#00000040] rounded-[10px] pt-1 overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          <div className="flex flex-col">
            {/* Header Info */}
            <div className="flex flex-row items-center justify-between px-2 w-full h-[60px]">
              <div className="flex flex-row items-center">
                <img
                  src={customer.avatar}
                  alt="Profile"
                  className="w-[45px] h-[45px] rounded-full object-cover"
                />
                <div className="flex flex-col gap-y-1 ml-2 w-[123px] h-[40px] justify-center">
                  <span className="text-[12px] font-semibold font-inter text-black leading-[100%]">
                    {customer.name}
                  </span>
                  <span className="text-[10px] font-medium font-inter text-black text-opacity-45 leading-[100%] tracking-[-0.03em]">
                    {customer.tier}
                  </span>
                </div>
              </div>
              <span className="text-[11px] font-medium font-inter text-black text-opacity-45 leading-[100%] tracking-[-0.03em]">
                session started {sessionStarted}
              </span>
            </div>

            {messages[0]?.timestamp && (
              <div className="flex items-center justify-center w-full">
                <div className="border-b border-[#0000002B] border-opacity-[17] w-full" />
                <span className="px-2 text-[10px] text-black text-opacity-50 font-inter whitespace-nowrap">
                  {messages[0]?.timestamp}
                </span>
                <div className="border-b border-[#0000002B] border-opacity-[17] w-full" />
              </div>
            )}

            {messages.map((msg, index) => (
              <div
                key={index}
                className={`w-full px-2 py-2 ${
                  msg.sender === "agent"
                    ? "flex justify-end"
                    : "flex justify-start"
                }`}
              >
                <div
                  className={`flex items-center gap-2 ${
                    msg.sender === "agent" ? "justify-end" : ""
                  }`}
                >
                  <div
                    className={`${
                      msg.sender === "agent"
                        ? "border border-[#00000073] border-opacity-[45]"
                        : "bg-[#B6B6B673]"
                    } flex items-center justify-center px-2 py-1 rounded-[8px] w-[90%]`}
                  >
                    <span className="text-[10px] font-inter text-black text-opacity-[45] leading-[130%]">
                      {msg.text}
                    </span>
                  </div>
                  {msg.sender !== "agent" && (
                    <div className="items-center cursor-pointer rounded-[8px] p-1 justify-center bg-[#DEDEDE73] bg-opacity-45">
                      <img
                        src="/icons/chat-ai.png"
                        alt="User"
                        className="w-[16px] h-[16px] object-contain"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <InputBar />
      </div>
    </div>
  );
};

export default CurrentChat;
